import { HomeMenuThemeModeConfig } from './types';

const dark: HomeMenuThemeModeConfig = {
  HomeMenu: {
    backgroundColor: '#505251',
    borderColor: '#267DAC',
    textColor: '#ffffff',
    backgroundIconColor: '#eeeeee'
  },
};

export default dark;
